module.exports = __webpack_public_path__ + "static/media/Decidr.9b69a8f3.png";